import React, { Component } from "react";
import {
  Text,
  View,
  Image,
  ScrollView,
  Platform,
  TouchableOpacity,
  ActivityIndicator,
  FlatList,
  ImageBackground,
} from "react-native";
import {
  Flex,
  Padding,
  Margin,
  Helpers,
  banner,
  pageContent,
  Colors,
} from "../../styles/appStyles";
import { helpers } from "../../utils/helpers";
import CustomImage from "../custom-image";
import getImagePath from "../../utils/image-helper";
// import { Colors } from 'react-native/Libraries/NewAppScreen';

const SuscriptionBg = getImagePath("img/suscription-top-section-bg.png");
const Mobilebanner = getImagePath("img/Mobilebanner.png");

class Banner extends Component {
  render() {
    const { bgColor, title, darkMode } = this.props;
    let webView = helpers.isWeb();
    return (
      <View
        source={Mobilebanner}
        style={[
          banner.Wrapper,
          Flex.row,
          helpers.isDesktop() ? Flex.alignCenter : Flex.alignEnd,
          {
            paddingVertical: 50,
            backgroundPosition: helpers.isDesktop() ? "center" : "right top",
            backgroundRepeat: "no-repeat",
            minHeight: helpers.isDesktop() ? 500 : 300,
            backgroundImage: helpers.isDesktop()
              ? "url(" + SuscriptionBg + ")"
              : "url(" + Mobilebanner + ")",
            backgroundSize: "cover",
          },
        ]}
      >
        <View
          style={[
            Helpers.conatinerWeb,
            helpers.isDesktop() && Helpers.conatinerWeb1200,
            { paddingHorizontal: 20 },
            helpers.isDesktop() && { flexDirection: "row" },
            helpers.isDesktop() ? Flex.alignCenter : Flex.alignEnd,
          ]}
        >
          <View style={[{ width: helpers.isDesktop() ? "80%" : "100%" }]}>
            <View
              style={[
                Margin.mb_15,
                Flex.row,
                ,
                !helpers.isDesktop() && { marginBottom: 8 },
              ]}
            >
              <View
                accessibilityRole="header"
                aria-level="1"
                style={[
                  !helpers.isDesktop() && {
                    flex: 1,
                    textAlign: helpers.isDesktop() ? "center" : "left",
                  },
                ]}
              >
                <Text
                  style={[
                    pageContent.sectionTitle,
                    helpers.isDesktop() && pageContent.sectionTitleDesktop,
                    {
                      fontSize: helpers.isDesktop() ? 64 : 32,
                      lineHeight: helpers.isDesktop() ? 84 : 41,
                      color: "#ffffff",
                    },
                    darkMode && { color: Colors.lightWhite },
                  ]}
                >
                  {title}
                </Text>
              </View>
            </View>
            <Text
              style={[
                pageContent.text,
                helpers.isDesktop() && pageContent.textDesktop,
                { marginBottom: helpers.isDesktop() ? 0 : 0, color: "#ffffff" },
                ,
                !helpers.isDesktop() && Helpers.textCenter,
                helpers.isDesktop() && { fontSize: 30 },
                !helpers.isDesktop() && { fontSize: 18 },
                darkMode && { color: Colors.lightWhite },
                { textAlign: helpers.isDesktop() ? "left" : "left" },
              ]}
            >
              Financial journalism and beyond. Paid for by subscribers, not
              advertisers.
            </Text>
          </View>
          <View
            style={{
              width: helpers.isDesktop() ? "30%" : "100%",
              alignItems: helpers.isDesktop() ? "flex-end" : "center",
            }}
          ></View>
        </View>
      </View>
    );
  }
}

export default Banner;
